__turbopack_context__.v({
  "animate": "WtwlKW_animate",
  "character": "WtwlKW_character",
  "character-entrance": "WtwlKW_character-entrance",
  "word": "WtwlKW_word",
});
